import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldPerson = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 13C12.9667 13 13.7917 12.6583 14.475 11.975C15.1583 11.2917 15.5 10.4667 15.5 9.5C15.5 8.53333 15.1583 7.70833 14.475 7.025C13.7917 6.34167 12.9667 6 12 6C11.0333 6 10.2083 6.34167 9.525 7.025C8.84167 7.70833 8.5 8.53333 8.5 9.5C8.5 10.4667 8.84167 11.2917 9.525 11.975C10.2083 12.6583 11.0333 13 12 13ZM12 22C9.56667 21.3833 7.625 20.05 6.175 18C4.725 15.95 4 13.65 4 11.1V5L12 2L20 5V11.1C20 13.65 19.275 15.95 17.825 18C16.375 20.05 14.4333 21.3833 12 22ZM12 19.9C12.9833 19.5833 13.8542 19.0875 14.6125 18.4125C15.3708 17.7375 16.0333 16.975 16.6 16.125C15.8833 15.7583 15.1375 15.4792 14.3625 15.2875C13.5875 15.0958 12.8 15 12 15C11.2 15 10.4125 15.0958 9.6375 15.2875C8.8625 15.4792 8.11667 15.7583 7.4 16.125C7.96667 16.975 8.62917 17.7375 9.3875 18.4125C10.1458 19.0875 11.0167 19.5833 12 19.9Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgShieldPerson);
export default ForwardRef;
